import { ApiClient } from "../types/client.types";
import { AppContext } from "../types/context.types";
import { QueryFunction } from "../types/query.types";
import { createApiClient } from "./createApiClient";

class MockAbort extends Error {}

const nullObject: any = new Proxy(
    {},
    {
        get: (_, prop) => {
            if (prop === "then") {
                return () => {
                    throw new MockAbort();
                };
            }
            return nullObject;
        },
        apply: () => nullObject,
    },
);

export function getCacheKey<T>(
    queryFn: QueryFunction<T>,
    context: AppContext,
    scope?: string,
): string[] {
    const key: string[] = scope ? [scope] : [];

    const urlCapture = (url: string) => {
        if (url) key.push(url);
        return nullObject;
    };

    const apiCapture = {
        ...createApiClient(),
        get: urlCapture,
        post: urlCapture,
        put: urlCapture,
        delete: urlCapture,
        patch: urlCapture,
        isMock: true,
    } as any as ApiClient;

    const safeContext = { ...context, api: apiCapture };

    try {
        (queryFn(safeContext) as Promise<T>)?.catch?.(() => {});
        // eslint-disable-next-line no-empty
    } catch (e) {}

    return key.length > 0 ? key : ["no-cache-key"];
}
